import React from "react";
import { Info } from "@phosphor-icons/react";

const COPY = {
  intake: {
    title: "Why intake matters",
    body: "The case caption, parties, court, and jurisdiction, is the first thing a clerk and judge see. Wrong party names, missing addresses, or filing in the wrong court are the most common reasons complaints are rejected before a judge ever considers the merits.",
  },
  questionnaire: {
    title: "Why the questionnaire matters",
    body: "Your claim type determines the legal elements you must prove. A clear summary and damages description shape every section that follows. Skipping detail here means the AI drafter and the reviewer will have to guess, and your complaint will read like guesswork.",
  },
  timeline: {
    title: "Why the timeline matters",
    body: "Courts expect concrete dates and events. A precise chronology grounds your factual allegations, surfaces statute-of-limitations issues early, and prevents internal contradictions that defendants will use to challenge your credibility.",
  },
  evidence: {
    title: "Why evidence organization matters",
    body: "Exhibits convert allegations into proof. Properly labeled exhibits (Exhibit A, B, C…) make your case easy for the court to follow and reduce the risk of late-evidence objections. Disorganized evidence is the fastest way to lose a winnable case.",
  },
  drafting: {
    title: "Why drafting matters",
    body: "Translating plain-English facts into court-ready legal prose is what makes a complaint survive an early motion to dismiss. Each section (Facts, Claims, Relief) must follow civil-procedure conventions and the local court's rules; sloppy drafting invites dismissal.",
  },
  review: {
    title: "Why the review check matters",
    body: "Missing parties, vague damages, and missing exhibits are the top reasons pro-se complaints are dismissed. A short completeness check before filing catches problems while they're easy to fix, instead of losing on a technicality.",
  },
  share: {
    title: "Why sharing with attorneys matters",
    body: "Many strong cases never get filed because the litigant couldn't connect with the right counsel. Sharing an anonymized summary lets attorneys evaluate fit before you reveal sensitive details, and lets the right lawyer find you instead of the other way around.",
  },
  preview: {
    title: "Why the final review matters",
    body: "PDF and DOCX exports follow the standard formatting clerks expect, but the document is still a draft. Always have a licensed attorney review the final complaint and the list of exhibits before filing. The disclaimer travels with the document, but the responsibility remains yours.",
  },
};

export default function WhyThisMatters({ step }) {
  const c = COPY[step];
  if (!c) return null;
  return (
    <section
      className="mt-10 border-l-4 border-slate-900 bg-slate-50 p-6"
      data-testid={`why-${step}`}
    >
      <div className="flex items-start gap-3">
        <Info weight="duotone" className="w-6 h-6 text-slate-900 shrink-0 mt-1" />
        <div>
          <div className="label-tiny mb-1">Why this step matters</div>
          <div className="font-serif-display text-2xl text-slate-900 leading-tight">{c.title}</div>
          <p className="text-sm text-slate-700 mt-2 leading-relaxed max-w-3xl">{c.body}</p>
        </div>
      </div>
    </section>
  );
}
